











import Vue from 'vue';

export default Vue.extend({
    props: {
        colors: {
            type: Array as () => ColorDefinition[],
            required: true,
        },
    },
    methods: {
        exportColors() {
            const lines = [
                'module.exports = {',
                '   theme: {',
                '       colors: {',
            ];

            const formatObjectKey = (name: string) => /-\s/.test(name) ? `'${name}'` : name;

            for (const color of this.colors) {
                const shadeEntries = Object.entries(color.shades);

                if (shadeEntries.length === 1 && shadeEntries[0][0] === 'default') {
                    lines.push(`            ${formatObjectKey(color.name)}: '${shadeEntries[0][1]}',`);

                    continue;
                }

                lines.push(`            ${formatObjectKey(color.name)}: {`);
                lines.push(
                    ...shadeEntries
                        .map(([shade, color]) => `                ${shade}: '${color}',`),
                );
                lines.push('            },');
            }

            lines.push(...[
                '        },',
                '    },',
                '};',
                '',
            ]);

            const url = window.URL.createObjectURL(
                new Blob([lines.join('\n')], {type: 'application/javascript'}),
            );
            const anchor = document.createElement('a');
            anchor.style.display = 'none';
            anchor.href = url;
            anchor.download = 'tailwind.config.js';
            document.body.appendChild(anchor);
            anchor.click();
            window.URL.revokeObjectURL(url);
        },
    },
});
